import { Link } from 'react-router-dom';
import { Clock, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

function formatDuration(seconds) {
  if (seconds < 60) return { value: seconds, unit: 'SECONDS' };
  if (seconds < 3600) return { value: Math.round(seconds / 60), unit: 'MINUTES' };
  return { value: (seconds / 3600).toFixed(1), unit: 'HOURS' };
}

export const TimeSavedCard = ({ timeSaved, tier }) => {
  if (!timeSaved) return null;
  const total = formatDuration(timeSaved.seconds);
  const month = formatDuration(timeSaved.this_month_seconds);
  const isPro = tier === 'pro';

  return (
    <div className="border-2 border-foreground p-5 md:p-6 mb-8 flex flex-col md:flex-row md:items-center gap-5" style={{ boxShadow: '4px 4px 0 0 hsl(var(--primary))' }} data-testid="time-saved-card">
      <div className="w-12 h-12 bg-primary text-primary-foreground flex items-center justify-center shrink-0">
        <Clock className="w-6 h-6" />
      </div>
      <div className="flex-1">
        <div className="text-[10px] uppercase tracking-widest text-muted-foreground mb-1">TIME SAVED NOT TYPING</div>
        <div className="font-heading text-4xl leading-none" data-testid="time-saved-total">
          {total.value} <span className="text-base tracking-widest text-muted-foreground">{total.unit}</span>
        </div>
        <p className="text-xs text-muted-foreground mt-2" data-testid="time-saved-breakdown">
          {timeSaved.fields_filled === 0
            ? 'Run your first autofill and watch this grow.'
            : `${timeSaved.fields_filled} fields across ${timeSaved.autofills} autofill${timeSaved.autofills === 1 ? '' : 's'} · ${month.value} ${month.unit.toLowerCase()} this month · ~${timeSaved.seconds_per_field}s per field`}
        </p>
      </div>
      {!isPro && (
        <Link to="/upgrade" data-testid="time-saved-upgrade-btn">
          <Button size="sm" className="uppercase tracking-widest text-xs">
            Save unlimited time with Pro <ArrowRight className="w-3.5 h-3.5 ml-1" />
          </Button>
        </Link>
      )}
    </div>
  );
};
